var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar",style:({
    background: _vm.color,
  })},[_c('div',{staticClass:"progress-bar__fill",style:({
      width: _vm.normalizedProgressPercent + '%',
      background: _vm.fillColor,
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }